import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-patreon',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Patreon icon</title><path d="M0 .48v23.04h4.22V.48zm15.385 0c-4.764 0-8.641 3.88-8.641 8.65 0 4.755 3.877 8.623 8.641 8.623 4.75 0 8.615-3.868 8.615-8.623C24 4.36 20.136.48 15.385.48z"/></svg>`,
    styles: []
})
export class SimpleIconsPatreonComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#F96854';
    @Input() className: string = 'simple-icons-patreon'
    constructor() {}
    ngOnInit(): void {}
}
